import type { SeparatorProps } from 'react-aria-components';
import { Separator } from 'react-aria-components';
import { twMerge } from 'tailwind-merge';

export function MenuSeparator({ className, ...props }: SeparatorProps) {
  return <Separator className={twMerge('border-b border-secondary-300', className)} {...props} />;
}
